import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./LoginPage";
import HomePage from "./HomePage";
import { AuthApi, ApiClient } from "./tradingApiSdk/src";

function detectApiBaseUrl() {
  const hostname = window.location.hostname;
  if (hostname.includes("beta")) {
    return "https://beta-api.edge.a1ultra.com";
  } else if (hostname.includes("127.0.0.1")) {
    return "http://127.0.0.1:5000";
  } else {
    return "https://api.edge.a1ultra.com";
  }
}

export default function App() {
  const [loggedIn, setLoggedIn] = useState(null);

  useEffect(() => {
    async function checkStatus() {
      try {
        const client = new ApiClient();
        client.basePath = detectApiBaseUrl();
        client.enableCookies = true;
        client.fetchOptions = { credentials: "include", cache: "no-cache" };

        const res = await fetch(`${client.basePath}/auth/status`, {
          credentials: "include",
          cache: "no-cache",
        });
        const data = await res.json();

        setLoggedIn(data.logged_in);
      } catch (err) {
        console.error("Status check error:", err);
        setLoggedIn(false);
        
      }
    }
    checkStatus();
  }, []);

  if (loggedIn === null) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={loggedIn ? <Navigate to="/" replace /> : <LoginPage onLoginSuccess={() => setLoggedIn(true)} />} />
        <Route path="/" element={loggedIn ? <HomePage onLogout={() => setLoggedIn(false)} /> : <Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}